import React from 'react';
import { Box, Container, Typography, Link, Divider, Grid, useTheme } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { 
  Calculate as CalculateIcon
} from '@mui/icons-material';
import { useThemeContext } from '../../contexts/ThemeContext';

function Footer() {
  const theme = useTheme();
  const { tenantInfo } = useThemeContext();
  const currentYear = new Date().getFullYear();

  return (
    <Box 
      component="footer" 
      sx={{ 
        mt: 'auto',
        py: 4, 
        backgroundColor: theme.palette.grey[100]
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          <Grid item xs={12} sm={4}>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
              <CalculateIcon sx={{ mr: 1, color: theme.palette.primary.main }} />
              <Typography variant="h6" color="primary" fontWeight="bold">
                {tenantInfo?.siteName || 'MathWiz League'}
              </Typography>
            </Box>
            <Typography variant="body2" color="text.secondary" paragraph>
              {tenantInfo?.tagline || 'Empowering middle school students with challenging math competitions and fostering problem-solving skills.'}
            </Typography>
            {/* <Box sx={{ display: 'flex', gap: 1 }}>
              <Link href="#" color="inherit">
                <FacebookIcon />
              </Link>
              <Link href="#" color="inherit">
                <TwitterIcon />
              </Link>
              <Link href="#" color="inherit">
                <InstagramIcon />
              </Link>
              <Link href="#" color="inherit">
                <YouTubeIcon />
              </Link>
            </Box> */}
          </Grid>
          
          <Grid item xs={12} sm={4}>
            <Typography variant="h6" color="text.primary" gutterBottom>
              Quick Links
            </Typography>
            <Link 
              component={RouterLink} 
              to="/about"
              color="text.secondary"
              display="block"
              sx={{ mb: 1 }}
            >
              About Us
            </Link>
            <Link 
              component={RouterLink} 
              to="/faq"
              color="text.secondary"
              display="block"
              sx={{ mb: 1 }}
            >
              FAQ
            </Link>
          </Grid>
          
          <Grid item xs={12} sm={4}>
            <Typography variant="h6" color="text.primary" gutterBottom>
              Contact Us
            </Typography>
            <Typography variant="body2" color="text.secondary" paragraph>
              Email: <Link href={`mailto:${tenantInfo?.contactEmail || 'mathwizleague@gmail.com'}`} color="primary" sx={{ textDecoration: 'underline' }}>
                {tenantInfo?.contactEmail || 'mathwizleague@gmail.com'}
              </Link>
            </Typography>
            {tenantInfo?.contactPhone && (
              <Typography variant="body2" color="text.secondary" paragraph>
                Phone: {tenantInfo.contactPhone}
              </Typography>
            )}
          </Grid>
        </Grid>
        
        <Divider sx={{ my: 3 }} />
        
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
          <Typography variant="body2" color="text.secondary">
            © {currentYear} {tenantInfo?.siteName || 'MathWiz League'}.
            {tenantInfo?.footerText ? ` ${tenantInfo.footerText}` : ' All rights reserved.'}
          </Typography>
          <Box>
            <Link
              component={RouterLink}
              to={tenantInfo?.privacyPolicyUrl || '/privacy'}
              color="text.secondary"
              sx={{ mx: 1 }}
            >
              Privacy Policy
            </Link>
            <Link
              component={RouterLink}
              to={tenantInfo?.termsUrl || '/terms'}
              color="text.secondary"
              sx={{ mx: 1 }}
            >
              Terms of Service
            </Link>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}

export default Footer;